import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LookupModel } from '@eightcap/core';

@Component({
    selector: 'eig-checkbox-group',
    templateUrl: './eig-checkbox-group.component.html',
})
export class EigCheckboxGroupComponent implements OnInit {
    @Input() readonly control: FormControl;
    @Input() readonly optionTypes: LookupModel[];
    checkboxForm: FormGroup;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.checkboxForm = this.formBuilder.group({
            checkboxGroup: new FormArray([]),
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['optionTypes'] && !changes.optionTypes.firstChange) {
            const checkboxGroupArray = this.checkboxForm.controls.checkboxGroup as FormArray;
            checkboxGroupArray?.clear();
            this.optionTypes.map((option) => checkboxGroupArray?.push(this.createCheckboxOptionsControl(option)));
        }
    }

    onSelectionChanged(element: FormGroup) {
        const code = element.controls.code.value;
        const options = this.control.value as Array<string>;
        if (element.controls.selected.value && options?.indexOf(code) == -1) {
            this.control.setValue([...options, code]);
        } else if (!element.controls.selected.value) {
            this.control.setValue(options.filter((cur) => cur !== code));
        }
    }

    private createCheckboxOptionsControl(option: LookupModel): FormGroup {
        return this.formBuilder.group({
            code: option.code,
            name: option.name,
            selected: new FormControl(
                this.control.value && this.control.value.indexOf(option.code) > -1 ? true : false
            ),
        });
    }
}
